import { getNationwide } from "./Nationwide";
import { vehicleDriversLicenseContent } from "./VehicleDriversLicense";
import { marriageContent } from "./Marriage";
import { vehicleDppaContent } from "./VehiclesDppa";
import { propertyContent } from "./Property";
import { watercraftContent } from "./Watercraft";
import { instantCriminalContent } from "./InstantCriminal";
import { professionalContent } from "./Professional";
import { huntingFishingContent } from "./HuntingFishing";
import { concealedContent } from "./Concealed";

const getDialogProps = (width, height, marginLeft, marginTop) => ({
  dialogWidth: width,
  dialogHeight: height,
  dialogMarginLeft: marginLeft,
  dialogMarginTop: marginTop
});

export const getCoverageAreaContent = (
  view,
  lowerCaseNoSpaceView,
  changeDialogProps
) => {
  if (!view) {
    return getNationwide();
  }
  switch (lowerCaseNoSpaceView) {
    case "driverlicense_driverlicense": {
      return vehicleDriversLicenseContent;
    }
    case "emailsocialmedia_socialmedia": {
      return getNationwide("world");
    }
    case "relationships_marriagedivorce": {
      changeDialogProps(getDialogProps("40%", "90%", "30%", "25px"));
      return marriageContent;
    }
    case "vehicles_vehicledppa":
    case "vehicles_":
    case "vehicles_driverhistory":
    case "vehicles_vin": {
      changeDialogProps(getDialogProps("80%", "90%", "10%", "25px"));
      return vehicleDppaContent;
    }
    case "property_property": {
      changeDialogProps(getDialogProps("40%", "90%", "30%", "25px"));
      return propertyContent;
    }
    case "watercrafts_watercraft": {
      changeDialogProps(getDialogProps("40%", "90%", "30%", "25px"));
      return watercraftContent;
    }
    case "criminal_instantcriminalcheck": {
      changeDialogProps(getDialogProps("80%", "90%", "10%", "25px"));
      return instantCriminalContent;
    }
    case "professional_professionallicense": {
      changeDialogProps(getDialogProps("60%", "90%", "20%", "25px"));
      return professionalContent;
    }
    case "huntingfishing_huntingfishing": {
      changeDialogProps(getDialogProps("40%", "75%", "30%", "100px"));
      return huntingFishingContent;
    }
    case "concealedweapons_concealedweapons": {
      changeDialogProps(getDialogProps("40%", "75%", "30%", "100px"));
      return concealedContent;
    }
    default:
      return getNationwide();
  }
};

export default getCoverageAreaContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/CoverageAreaContent.js